import { render, staticRenderFns } from "./TableManagementForm.vue?vue&type=template&id=b25f4b54&scoped=true&"
import script from "./TableManagementForm.vue?vue&type=script&lang=js&"
export * from "./TableManagementForm.vue?vue&type=script&lang=js&"
import style1 from "./TableManagementForm.vue?vue&type=style&index=1&id=b25f4b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25f4b54",
  null
  
)

export default component.exports